<span class="badge">{{ labelName }}</span>
